{"browse_shop":"Navegar na loja","go_to_shop":"Ir para a loja","no_orders_found":"Nenhum pedido encontrado","title":"Pedidos"}